import {combineReducers} from 'redux'
import scenes from "./scenes"
import popup from "./popup";

export default combineReducers({scenes, popup});
